import type { Member } from '../model';

import { RECENTLY_ACTIVE_LIMIT, RECENTLY_ACTIVE_WINDOW_DAYS } from './constants';

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Members last seen in the last N days, newest first, capped.
 * Missing or 0 `_lastSeen` means Never — those are excluded.
 */
export function getRecentlyActiveMembers(members: readonly Member[], now = Date.now()): Member[] {
  const cutoff = now - RECENTLY_ACTIVE_WINDOW_DAYS * DAY_MS;

  return members
    .filter((member) => {
      const lastSeen = member._lastSeen;
      return typeof lastSeen === 'number' && lastSeen > 0 && lastSeen >= cutoff;
    })
    .sort((a, b) => (b._lastSeen ?? 0) - (a._lastSeen ?? 0))
    .slice(0, RECENTLY_ACTIVE_LIMIT);
}
